import React from 'react';
import { connect } from 'react-redux';
import FullPageLayout from '../../components/layouts/FullPageLayout';
import CreateNewRetailerAccount from '../../components/blocks/CreateNewRetailerAccount';
import { postNewRetailer } from '../../store/actions/newRetailer';

function CreateNewRetailerAccountPage(props) {
  return (
    <FullPageLayout size="xlarge" logout>
      <CreateNewRetailerAccount {...props} />
    </FullPageLayout>
  );
}

const mapDispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(postNewRetailer(data)),
});

export default connect(null, mapDispatchToProps)(CreateNewRetailerAccountPage);
